export default "__VITE_ASSET__DNnokCDU__"